import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { PaddingGroup } from '../padding'
import { BorderRadiusControl } from '../../controls/border-radius-control'
import {
  WebsiteButtonsInterface,
  WebsiteButtonStyleEnum,
  WebsiteFormFieldsSettings,
} from 'src/shared/types/website-settings-types'
type WebsiteStyles = WebsiteButtonsInterface & WebsiteFormFieldsSettings
interface ButtonAndFormFieldStyleGroupProps {
  updateWebsiteStyles: <Key extends keyof WebsiteStyles>(
    prop: Key,
  ) => (value: WebsiteStyles[Key]) => void
  styleSettings: WebsiteButtonsInterface | WebsiteFormFieldsSettings
}

export const ButtonAndFormFieldStyleGroup = ({
  updateWebsiteStyles,
  styleSettings,
}: ButtonAndFormFieldStyleGroupProps) => {
  return (
    <OptionWrapper
      labelClassName="mb-0.5"
      labelText="website_styles_settings.buttons_and_links.style.title"
    >
      <Switcher
        btnList={[
          {
            value: WebsiteButtonStyleEnum.Filled,
            content: 'website_styles_settings.buttons_and_links.style.filled',
          },
          {
            value: WebsiteButtonStyleEnum.Outlined,
            content: 'website_styles_settings.buttons_and_links.style.outlined',
          },
        ]}
        update={updateWebsiteStyles('style')}
        value={styleSettings?.style || ''}
        className="p-0"
        btnClassName="flex justify-center items-center h-10 [&>svg]:w-5 [&>svg]:h-5"
      />
      <div className="flex gap-3">
        <PaddingGroup
          padding={styleSettings.padding}
          update={updateWebsiteStyles('padding')}
          label=""
          withoutExpandButton
        />
        <BorderRadiusControl
          label=""
          border={styleSettings.border}
          update={updateWebsiteStyles('border')}
          withoutExpandButton
        />
      </div>
    </OptionWrapper>
  )
}
